import LoadingButton from '@mui/lab/LoadingButton';
import CircularProgress from '@mui/material/CircularProgress';

const Loadingalert = () => {
    return (
    <LoadingButton loading loadingPosition="end" endIcon={<CircularProgress size={20}/>} variant='contained' size="large" ><span>Loading.....</span></LoadingButton>
      );
}
 
export default Loadingalert;